
import { isAnnotationLocked } from '../utils/annotationLockUtils';
import randomId from '../utils/randomId';

export const DUPLICATE_ANNOTATIONS = 'DUPLICATE_ANNOTATIONS';

const duplicateAnnotations = (state, payload) => {
  const { annotations } = state;
  const duplicatedAnnotations = {};
  payload.annotationsIds.forEach((id) => {
    const annotation = annotations[id];
    if (annotation && !isAnnotationLocked(annotation)) {
      const clonedAnnotationId = randomId(annotation.name);
      const { groupId, ...annotationWithoutGroup } = annotation;
      duplicatedAnnotations[clonedAnnotationId] = {
        ...annotationWithoutGroup,
        id: clonedAnnotationId,
        x: annotation.x + 20,
        y: annotation.y + 20,
      };
    }
  });

  if (Object.keys(duplicatedAnnotations).length === 0) {
    return state;
  }

  return {
    ...state,
    // not stored in state, used in reducer to consider in undo/redo stacks
    isDesignState: !payload.dismissHistory,
    annotations: {
      ...annotations,
      ...duplicatedAnnotations,
    },
  };
};

export default duplicateAnnotations;
